import config from "config";

export const MAPBOX_ACCESS_TOKEN =
  config.MAPBOX_ACCESS_TOKEN_3D || config.MAPBOX_ACCESS_TOKEN;

// Global scenario map configuration
const scenarioMapConfig = {
  container: {
    width: "100%",
    height: "70vh",
    overflow: "hidden",
  },

  map: {
    style: "mapbox://styles/mapbox/dark-v11",
    center: [22.95, 40.64],
    zoom: 12,
    minZoom: 3,
    maxZoom: 20,
    pitch: 0,
    bearing: 0,
  },

  draw: {
    defaultMode: "simple_select",
    controls: {
      point: true,
      line_string: true,
      trash: false,
    },
  },

  // ------------------------------------
  // LAYER CONFIGURATION HERE 
  // ------------------------------------

  layers: {
    // ------------------------------------------
    // NETWORK (used only for draw guidance)
    // ------------------------------------------
    network: {
      sourceId: "scenario-network",
      layerId: "scenario-network-line",
      type: "line",
      layout: {
        visibility: "none",
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": "#888",
        "line-width": 8,
        "line-opacity": 0.5,
      },
      fitBoundsPadding: 40,
    },

    // ------------------------------------------
    // EVENTS: points + symbol-on-linestring
    // ------------------------------------------
    events: {
      pointSourceId: "scenario-events-points",
      pointLayerId: "scenario-events-point-layer",
      lineSymbolSourceId: "scenario-events-line-symbols",
      lineSymbolLayerId: "scenario-events-line-symbol-layer",

      pointLayout: {
        "icon-size": 1.0,
        "text-size": 11,
        "text-offset": [0, 1.2],
      },

      lineSymbolLayout: {
        "icon-size": 1.0,
        "text-size": 11,
        "text-offset": [0, 1.2],
      },
    },

    // ------------------------------------------
    // ROUTES: merged link segments
    // ------------------------------------------
    routes: {
      sourceId: "scenario-routes",
      layerId: "scenario-routes-line",

      layout: {
        "line-cap": "round",
        "line-join": "round",
      },

      paint: {
        "line-width": 6,
        "line-opacity": 0.85,
        "line-color": ["get", "color"], // color from props
      },
    },

    // ------------------------------------------
    // AREAS: fill + outline
    // ------------------------------------------
    areas: {
      sourceId: "scenario-areas",
      fillLayerId: "scenario-areas-fill",
      outlineLayerId: "scenario-areas-outline",

      fillPaint: {
        "fill-color": "#777",
        "fill-opacity": 0.25,
      },

      outlinePaint: {
        "line-color": "#555",
        "line-width": 2,
      },
    },
  },
};

export default scenarioMapConfig;
